<template>
    <a @click="logout" class="btn btn-sm btn-danger transition-3d-hover" href="#">Se déconnecter</a>
</template>

<script>
    import {mapMutations} from "vuex";

    export default {
        name: "Logout",
        methods: {
            ...mapMutations([
                'removeUserAuthToken'
            ]),
            logout() {
                this.removeUserAuthToken();
                this.$router.push({'name': 'welcome'});
            },
        }
    }
</script>

<style scoped>

</style>